import { Consumer, createConsumer, Subscription } from '@rails/actioncable'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { queryClient } from '../store/provider/TanStackProvider'

let consumer: Consumer | null
let subscription: Subscription | null
let subscribersCount = 0

const createCableUrl = () => {
  const uid = Cookies.get('uid')
  const accessToken = Cookies.get('access-token')
  const client = Cookies.get('client')
  const apiBaseUrl = process.env.REACT_APP_API_URL

  if (!uid || !accessToken || !client || !apiBaseUrl) return null

  const wsBaseUrl = apiBaseUrl
    .trim()
    .replace(/\/+$/, '')
    .replace(/^http:/, 'ws:')
    .replace(/^https:/, 'wss:')
  return `${wsBaseUrl}/cable?uid=${encodeURIComponent(uid)}&access-token=${encodeURIComponent(
    accessToken
  )}&client=${encodeURIComponent(client)}`
}

const ensureMedicationOrdersSubscription = () => {
  if (consumer && subscription) return

  const cableUrl = createCableUrl()

  if (!cableUrl) return

  try {
    consumer = createConsumer(cableUrl)
    subscription = consumer.subscriptions.create(
      { channel: 'MedicationOrdersChannel' },
      {
        received() {
          queryClient.invalidateQueries({ queryKey: ['medication'] })
          queryClient.invalidateQueries({ queryKey: ['medication_administration'] })
          queryClient.invalidateQueries({ queryKey: ['patient_medications'] })
        }
      }
    )
  } catch (error) {
    console.error('ActionCable setup failed:', error)
  }
}

const cleanupMedicationOrdersSubscription = () => {
  if (subscribersCount > 0) return

  subscription?.unsubscribe?.()
  consumer?.disconnect?.()
  subscription = null
  consumer = null
}

export const useMedicationOrdersSubscription = (enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return

    subscribersCount += 1
    ensureMedicationOrdersSubscription()

    return () => {
      subscribersCount = Math.max(0, subscribersCount - 1)
      cleanupMedicationOrdersSubscription()
    }
  }, [enabled])
}
